<template>
  <MenuWidget as="div" class="relative inline-block text-left channel-menu z-10">
    <div>
      <MenuButton class="inline-flex justify-center w-full rounded-md shadow-sm bg-white text-sm font-medium text-gray-700">
        <ChannelLabel v-if="channel" :channel="channel" iconOnly="true" noflex="true" />
      </MenuButton>
    </div>
    <transition enter-active-class="transition ease-out duration-100" enter-from-class="transform opacity-0 scale-95" enter-to-class="transform opacity-100 scale-100" leave-active-class="transition ease-in duration-75" leave-from-class="transform opacity-100 scale-100" leave-to-class="transform opacity-0 scale-95">
      <MenuItems style="inset: auto auto 0 0;transform: translate(0px, -48px);" class="origin-top-right absolute right-0 mt-2 w-56 rounded-md shadow-lg bg-white ring-1 ring-black ring-opacity-5 divide-y divide-gray-100 focus:outline-none  border border-gray-300">
        <div class="py-1">
          <MenuItem v-slot="{ active }" v-for="channel of activeChannels" v-bind:value="selectedChannel.id" v-bind:key="channel.id">
            <a href="#" @click="setCurrentChannel(channel)" :class="[active || selectedChannel.id === channel.id ? 'font-semibold bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-sm overflow-hidden']">
              <ChannelLabel :channel="channel" />
            </a>
          </MenuItem>
          <MenuItem v-slot="{ active }" v-for="channel of whatsappReopenableChannels" v-bind:value="selectedChannel.id" v-bind:key="channel.id">
            <a href="#" @click="setCurrentChannel(channel)" :class="[active || selectedChannel.id === channel.id ? 'font-semibold bg-gray-100 text-gray-900' : 'text-gray-700', 'group flex items-center px-4 py-2 text-sm overflow-hidden']">
              <ChannelLabel :channel="channel" />
            </a>
          </MenuItem>
          <MenuItem v-for="channel of inactiveChannels" v-bind:value="selectedChannel.id" v-bind:key="channel.id">
            <span class="grayscale text-gray-700 group flex items-center px-4 py-2 text-sm overflow-hidden">
              <ChannelLabel :channel="channel" :inactive="true" />
            </span>
          </MenuItem>
        </div>
      </MenuItems>
    </transition>
  </MenuWidget>
</template>


<script>
import ChannelLabel from './ChannelLabel.vue'
import { useWhatsappMessagesStore } from '@/stores/whatsappMessageTemplates';

import { Menu as MenuWidget, MenuButton, MenuItem, MenuItems } from '@headlessui/vue'

export default {
  name: 'ChannelSelect',
  props: ['channels', 'conversationId', 'selectedChannel', 'deletedChannels'],
  emits: ['channel-selected'],
  components: {
    ChannelLabel,
    //
    MenuWidget,
    MenuButton,
    MenuItem,
    MenuItems,
  },
  setup() {
    let whatsappMessagesStore = useWhatsappMessagesStore();
    return {
      whatsappMessagesStore,
    };
  },
  created() {
    this.selectChannel();
  },
  methods: {
    setCurrentChannel(channel) {
      this.$emit('channel-selected', channel);
      this.channel = channel;
    },
    selectChannel() {
      this.channel = this.selectedChannel;
    }
  },
  watch: {
    conversationId: function(newId) {
      if (newId) {
        this.selectChannel();
      }
    },
  },
  computed: {
    activeChannels() {
      return this.channels.filter(ch => {
        return this.deletedChannels.indexOf(ch.attributes.identifier) === -1 && ch.attributes['reply-window-open'];
      });
    },
    whatsappReopenableChannels() {
      return this.channels.filter(ch => {
        return this.deletedChannels.indexOf(ch.attributes.identifier) === -1 && !ch.attributes['reply-window-open'] && ch.attributes.type === 'whatsapp' && this.hasWhatsappTemplates;
      });
    },
    inactiveChannels() {
      return this.channels.filter(ch => {
        return this.deletedChannels.indexOf(ch.attributes.identifier) === -1 && !ch.attributes['reply-window-open'] && this.whatsappReopenableChannels.indexOf(ch) === -1;
      });
    },
    hasWhatsappTemplates() {
      return this.whatsappMessagesStore.activeTemplates().length > 0;
    },
  },
  data() {
    return {
      channel: undefined,
    }
  },
}
</script>
